// Darkside Detailing service packages
// All prices in CAD · Subject to HST

export const LOGO_URL = "/darkside-logo-horizontal.webp";

export const VEHICLE_TYPES = [
  {
    id: "sedan",
    label: "Cars",
    short: "Car",
    examples: "Sedans, coupes, hatchbacks (Civic, Corolla, Model 3, Camry, Sonata…)",
  },
  {
    id: "suv",
    label: "SUVs & Half-Ton (1500) Trucks",
    short: "SUV / Half-Ton",
    examples: "RAV4, CR-V, Rogue, Escape, F-150, Silverado 1500, RAM 1500…",
  },
  {
    id: "large",
    label: "Larger SUVs (7-Passenger), Vans & 2500+ Trucks",
    short: "Larger SUV / Van / Truck",
    examples: "Suburban, Tahoe, Yukon XL, Sienna, Odyssey, Sprinter, F-250, RAM 2500…",
  },
];

const _SERVICES_RAW = [
  {
    id: "wash-wax",
    name: "Wash & Wax",
    tagline: "Wet-look shine, protected.",
    description:
      "Pre-rinse, foam cannon application, microfiber pad scrub, rims and tires cleaned, and DI water rinse to prevent water spots. Choice of spray wax or hard wax for added shine and protection.",
    features: [
      "Pre-rinse + foam cannon",
      "Microfiber pad scrub",
      "Rims & tires cleaned",
      "DI water rinse",
      "Spray or hard wax",
    ],
    duration: "1h 30",
    pricing: { sedan: 150, suv: 170, large: 190 },
    addons: {
      sedan: [
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 50 },
      ],
      suv: [
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 75 },
      ],
      large: [
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 100 },
      ],
    },
    image: "/services/wash-wax.webp",
  },
  {
    id: "express-interior",
    name: "Express Interior Detail",
    tagline: "Quick refresh, factory-fresh feel.",
    description:
      "Detailing of dash, vinyl, plastics, doors, trims, and jambs. Vacuum of carpets, seats, mats, and trunk. Interior windows cleaned and shine applied to doors and dash.",
    features: [
      "Full vacuum of carpets, seats, mats & trunk",
      "Dash, vinyl, doors, trims & jambs detailed",
      "Interior windows cleaned",
      "Shine applied to doors & dash",
    ],
    duration: "2h",
    pricing: { sedan: 150, suv: 170, large: 190 },
    addons: {
      sedan: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 30 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
      ],
      suv: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 40 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
      ],
      large: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 50 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 20 },
      ],
    },
    image: "/services/express-interior.webp",
  },
  {
    id: "premium-interior-exterior",
    name: "Premium Interior + Exterior Detail",
    tagline: "Inside & out, done properly.",
    description:
      "Interior: dash, vinyl, plastics, doors, trims and jambs detailed. Vacuum of carpets, seats, mats and trunk. Interior windows cleaned; shine applied to doors and dash. Exterior: pre-rinse, foam cannon, microfiber pad scrub, rims & tires cleaned, DI water rinse.",
    features: [
      "Premium interior detail",
      "Pre-rinse + foam cannon exterior",
      "Rims & tires cleaned",
      "DI water rinse (no wax by default)",
    ],
    duration: "2h 30",
    pricing: { sedan: 200, suv: 220, large: 240 },
    addons: {
      sedan: [
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 85 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 30 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
        { id: "spray-waxing", name: "Spray Waxing", price: 30 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 50 },
      ],
      suv: [
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 110 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 40 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
        { id: "spray-waxing", name: "Spray Waxing", price: 40 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 75 },
      ],
      large: [
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 110 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 50 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 20 },
        { id: "spray-waxing", name: "Spray Waxing", price: 50 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 100 },
      ],
    },
    image: "/services/premium-interior-exterior.webp",
  },
  {
    id: "signature-wash-wax-interior",
    name: "Signature Wash, Wax & Interior Detail",
    tagline: "Refresh & protect — inside and out.",
    description:
      "A complete maintenance detail designed to refresh and protect your vehicle inside and out. Exterior: pre-rinse, foam cannon, safe microfiber hand wash, rims & tires cleaned, DI water rinse, and your choice of spray or hard wax. Interior: dash, vinyl, plastics, doors, trims & jambs cleaned; full vacuum of carpets, seats, mats & trunk; interior windows cleaned streak-free; protective shine applied to dash & door pan.",
    features: [
      "Pre-rinse + foam cannon + microfiber hand wash",
      "Rims & tires cleaned",
      "DI water rinse (no water spots)",
      "Choice of spray wax or hard wax",
      "Full interior vacuum, dash, vinyl & jambs",
      "Interior windows streak-free",
    ],
    duration: "3h",
    pricing: { sedan: 280, suv: 305, large: 325 },
    addons: {
      sedan: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 30 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 50 },
      ],
      suv: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 40 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 75 },
      ],
      large: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 50 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 20 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 100 },
      ],
    },
    image: "/services/wash-wax.webp",
  },
  {
    id: "premium-interior-shampoo",
    name: "Premium Interior + Shampooing",
    tagline: "Deep restoration for lived-in interiors.",
    description:
      "Detailing of dash, vinyl, plastics, doors, trims and jambs. Vacuum of carpets, seats, mats and trunk. Interior windows cleaned and shine applied to doors and dash. Shampoo or steam clean of mats, floors, and seats (as needed). Stain removal not guaranteed.",
    features: [
      "Everything in Express Interior",
      "Shampoo / steam extraction",
      "Mats, floors & seats treated",
      "Stain lift (best-effort)",
    ],
    duration: "2h 30",
    pricing: { sedan: 230, suv: 250, large: 270 },
    addons: {
      sedan: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 30 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
      ],
      suv: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 40 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 10 },
      ],
      large: [
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 50 },
        { id: "rubber-mats", name: "Rubber Mats (Pressure Washed)", price: 20 },
      ],
    },
    image: "/services/premium-interior-shampoo.webp",
  },
  {
    id: "darkside-detail",
    name: "Darkside Detail",
    tagline: "The full experience — inside, outside, shampooed.",
    description:
      "Our namesake package. Detailing of dash, vinyl, plastics, doors, trims and jambs. Full vacuum. Interior windows and dash shine. Shampoo or steam clean of mats, floors and seats (as needed). Exterior: pre-rinse, foam cannon, microfiber pad scrub, rims & tires cleaned, DI water rinse. Stain removal not guaranteed.",
    features: [
      "Full interior detail",
      "Shampoo / steam extraction",
      "Full exterior wash & foam decontamination",
      "Rims, tires & jambs",
      "3 hours of hand work",
    ],
    duration: "3h",
    pricing: { sedan: 280, suv: 300, large: 320 },
    addons: {
      sedan: [
        { id: "hand-wax", name: "Hand Wax (Carnauba)", price: 60 },
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 85 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 30 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "spray-waxing", name: "Spray Waxing", price: 30 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 50 },
      ],
      suv: [
        { id: "hand-wax", name: "Hand Wax (Carnauba)", price: 85 },
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 110 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 40 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "spray-waxing", name: "Spray Waxing", price: 40 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 75 },
      ],
      large: [
        { id: "hand-wax", name: "Hand Wax (Carnauba)", price: 85 },
        { id: "hand-wax-clay", name: "Hand Wax (Carnauba) & Clay Bar Decon", price: 110 },
        { id: "odor", name: "Odor Eliminator (bomb/spray)", price: 40 },
        { id: "pet-hair", name: "Pet Hair Removal", price: 50 },
        { id: "rainx", name: "RainX (Windshield)", price: 10 },
        { id: "spray-waxing", name: "Spray Waxing", price: 50 },
        { id: "tree-sap", name: "Tree Sap Removal", price: 100 },
      ],
    },
    image: "/services/darkside-detail.webp",
    highlight: true,
  },
];

// Display order for booking widget, services grid, and service pages.
// The single "MOST POPULAR" badge lives on darkside-detail — the namesake package.
const _SERVICE_DISPLAY_ORDER = [
  "darkside-detail",
  "premium-interior-exterior",
  "express-interior",
  "premium-interior-shampoo",
  "signature-wash-wax-interior",
  "wash-wax",
];

export const SERVICES = _SERVICES_RAW
  .map((s) => ({ ...s, popular: s.id === "darkside-detail" }))
  .sort((a, b) => {
    const ia = _SERVICE_DISPLAY_ORDER.indexOf(a.id);
    const ib = _SERVICE_DISPLAY_ORDER.indexOf(b.id);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });

// Helper: price for service × vehicle
export function getBasePrice(serviceId, vehicleId) {
  const s = SERVICES.find((x) => x.id === serviceId);
  return s?.pricing?.[vehicleId] ?? 0;
}

// Helper: add-ons for service × vehicle
export function getAddons(serviceId, vehicleId) {
  const s = SERVICES.find((x) => x.id === serviceId);
  return s?.addons?.[vehicleId] ?? [];
}

// Helper: total (base + selected add-ons)
export function computeTotal(serviceId, vehicleId, selectedAddonIds = []) {
  const base = getBasePrice(serviceId, vehicleId);
  const addons = getAddons(serviceId, vehicleId);
  const addonSum = addons
    .filter((a) => selectedAddonIds.includes(a.id))
    .reduce((sum, a) => sum + a.price, 0);
  return base + addonSum;
}

export const TIME_SLOTS = [
  "9:00 AM", "9:30 AM",
  "10:00 AM", "10:30 AM",
  "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM",
  "1:00 PM", "1:30 PM",
  "2:00 PM", "2:30 PM",
  "3:00 PM", "3:30 PM",
  "4:00 PM", "4:30 PM",
  "5:00 PM", "5:30 PM",
];

export const FRIDAY_SLOTS = [
  "9:00 AM", "9:30 AM",
  "10:00 AM", "10:30 AM",
  "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM",
  "1:00 PM", "1:30 PM",
];

// Returns 30-min start slots for a given date (used for admin block-time-off UI).
export function getSlotsForDate(date) {
  if (!date) return TIME_SLOTS;
  return date.getDay() === 5 ? FRIDAY_SLOTS : TIME_SLOTS;
}

export const SEASON = {
  startMonth: 3, // April (0-indexed)
  endMonth: 10, // November (0-indexed)
  label: "April – November",
  offSeasonLabel: "December – March (closed for the season)",
};

export function isInSeason(date) {
  const m = date.getMonth();
  return m >= SEASON.startMonth && m <= SEASON.endMonth;
}

export const BUSINESS = {
  name: "Darkside Detailing",
  brand: "DARKSIDE",
  phone: "782-321-9302",
  phoneHref: "tel:+17823219302",
  email: "darksidedetailingbusiness@gmail.com",
  emailHref: "mailto:darksidedetailingbusiness@gmail.com",
  hours: "Mon – Thu · 8:00 AM – 6:00 PM  ·  Fri · 8:00 AM – 2:00 PM",
  season: "Booking season: April – November",
  offSeason: "Closed December through March",
  area: "Halifax Regional Municipality (HRM)",
  base: "Dartmouth, Nova Scotia",
  since: "2021",
  facebook: "https://www.facebook.com/Darksid3Detailing/",
  facebookReviews: "https://www.facebook.com/Darksid3Detailing/reviews",
  instagram: "https://www.instagram.com/darksid3detailing/",
  googleReviews: "https://share.google/exMmEfb7blwB1kul5",
  legacyBooking: "https://darksidedetailingbooking.as.me/schedule.php",
  hstNote: "All prices in CAD. HST applied at checkout.",
  bioHazardFee: "A $50 fee applies for removal of excessive garbage, personal items or bio hazards.",
};
